<template>
  <div v-if="amReady">
    <app-board class="mb-2"
               v-if="!$store.getters['user-state/isUserCustomer'] && !$store.getters['user-state/isUserReseller']">
      <el-row class="pt-1 pl-2 pr-2 m-0">
        <el-col :class="$langConfig.cssClass" class="m-0" style="max-width: 150px" v-if="false">
          <dg-select-field
              :control="control"
              :field_span="22"
              :label_span="22"
              :options="divisionsList"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="divisionUpdated"
              field_mark=""
              label="Division"
              name="division_id"
              rules=""></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="m-0">
          <dg-select-field
              :field_span="22"
              :label_span="22"
              :options="searchPropertyOptions"
              :translateLabel="false"
              :translateLabels="false"
              @amUpdated="searchPropertyUpdated"
              field_mark=""
              htmlautocomplete="new-password"
              label="Search Property"
              name="search_property"
              placeholder=""
          ></dg-select-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 4 : 4" class="m-0">
          <dg-text-field
              :control="control"
              :field_span="22"
              :label_span="22"
              :translateLabel="false"
              @amUpdated="searchValueUpdated"
              field_mark=""
              label="Search Value"
              name="search_value"
              placeholder=""
          ></dg-text-field>
        </el-col>
        <el-col :class="$langConfig.cssClass" style="max-width: 100px">
          <el-button @click="searchDestinations" class="mt-4 p-2" icon="el-icon-search" size="mini"
                     type="primary"></el-button>
          <el-button @click="resetSearchFields" class="mt-4 p-2" icon="el-icon-close" size="mini"
                     type="info"></el-button>
        </el-col>
        <el-col :class="$langConfig.cssClass" :span="(!editMode)? 10: 10" class="pt-1 text-right">
          <pagination
              :currentPage="currentPage"
              :margin-pages="2"
              :navigateHandler="navigateToPage"
              :page-count="getPagesCount()"
              :page-range="3"
              class="mt-3 d-inline-block"
              paginateClass=""></pagination>
          <downloadWorkingDestinationsButton class="ml-3 mt-3 d-inline-block"
                                             label="Working"></downloadWorkingDestinationsButton>
        </el-col>
      </el-row>
    </app-board>

    <app-board>
      <app-ag-grid :agGrid="agGrid"></app-ag-grid>
    </app-board>
  </div>
</template>

<script>

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'

import callTestStatusViewer from "@/components/call-test-status-viewer/View";
import fieldController from 'devegram-vue-data-collecter-eui/src/mixins/fieldController';

let globalContext = null
export default {
  mixins: [fieldController],
  components: {
    pagination: () => import('@/components/pagination/View.vue'),
    downloadWorkingDestinationsButton: () => import('@/components/download-working-destinations/View')
  },
  props: {
    statusId: {
      required: true,
      type: Number
    },
  },
  data() {
    return {
      defaultRouteDivision: this.$route.params.division,
      divisionsList: [],
      searchProperty: '',
      searchValue: '',
      selectedDivision: '',
      searchPropertyOptions: [
        {
          label: 'Destination',
          value: 'destination'
        },
        {
          label: 'Vendor',
          value: 'vendor'
        },
        {
          label: 'Dial Code',
          value: 'dialcode'
        }
      ],
      userSearchTimeOut: null,
      hasColumnBeenResized: 213,
      dataModel: {
        destination_id: '',
        vendor_id: ''
      },
      amReady: false,
      module: {
        ...module
      },
      control: this,
      userSearch: '',
      currentPage: 1,
      pageChunkSize: 20,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      selectedCellValue: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: false,
          enableCellTextSelection: true,
          ensureDomOrder: true,
          enableRangeSelection: true,
          enableRangeHandle: true,
          onGridReady: function (params) {
            setTimeout(() => {
              params.api.sizeColumnsToFit()
            }, 200)
          },
          onCellClicked: this.onCellClicked,
          onColumnResized: function (params) {
            if (!globalContext.hasColumnBeenResized) {
              //params.api.sizeColumnsToFit()
              globalContext.hasColumnBeenResized = true
            }
          }
        },
        columnDefs: [
          {
            field: 'destination',
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'vendor',
            headerName: (($store.getters['user-state/isUserCustomer']) ? 'Prefix' : 'Vendor'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'division',
            width: 120,
            headerName: 'Division',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcode',
            width: 100,
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          }
          ,/*
          {
            width: 80,
            headerName: this.$ml.get('actions'),
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            cellRendererFramework: $vue.extend(actionsCell),
            cellRendererParams: {
              props: {
                actionsHandler: this.actionsHandler
              }
            }
          }*/
        ],
        rowData: []
      }
    };
  },
  mounted() {
    // Add keyboard event listener for copy functionality
    document.addEventListener('keydown', this.handleKeyDown);
  },
  beforeDestroy() {
    // Remove event listener to prevent memory leaks
    document.removeEventListener('keydown', this.handleKeyDown);
  },
  beforeMount() {
    this.getDivisionsDropDownList().then(r => {
      this.divisionsList = r
      this.divisionsList.unshift({
        'label': 'None',
        'value': ''
      })
      this.amReady = true
    })

    if ($store.getters['user-state/isUserRoot']) {
      this.agGrid.columnDefs.push({
        field: 'rate',
        width: 120,
        headerName: 'Rate',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true
      })
    }

    if ($store.getters['user-state/isUserRoot'] || $store.getters['user-state/isUserPlatformEmployee'] || $store.getters['user-state/isUserAdmin']) {
      this.agGrid.columnDefs.push({
        field: 'prefix',
        width: 100,
        headerName: 'Prefix',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true
      })
    }


    this.agGrid.columnDefs.push({
      field: 'created_at',
      width: 120,
      headerName: 'Time',
      headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
      autoHeight: true
    })


    this.agGrid.columnDefs.push({
      field: 'status',
      width: 120,
      headerName: 'Status',
      headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
      autoHeight: true,
      cellRendererFramework: $vue.extend(callTestStatusViewer),
      cellRendererParams: {
        props: {
          actionsHandler: this.actionsHandler
        }
      }
    })

    globalContext = this;

    this.currentPage = parseInt(this.$route.params.listPage)
    this.getEntityListData(this.currentPage)
  },
  methods: {
    handleKeyDown(event) {
      // Check if Ctrl+C (or Cmd+C on Mac) is pressed
      if ((event.ctrlKey || event.metaKey) && event.key === 'c') {
        // Check if there's any text selected by the user
        const selectedText = window.getSelection().toString();
        
        if (selectedText && selectedText.trim() !== '') {
          // If user has selected text, let the browser handle the copy (don't prevent default)
          return;
        } else if (this.selectedCellValue !== null) {
          // Only copy the full cell value if no text is selected
          this.copyToClipboard(this.selectedCellValue);
          event.preventDefault(); // Prevent default copy behavior
        }
      }
    },
    onCellClicked(params) {
      // Store the selected cell value
      this.selectedCellValue = params.value || '';
    },
    async copyToClipboard(text) {
      try {
        if (navigator.clipboard && window.isSecureContext) {
          // Use modern clipboard API
          await navigator.clipboard.writeText(text);
        } else {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = text;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
        // Optional: Show a notification that text was copied
        console.log('Copied to clipboard:', text);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }
    },
    searchDestinations() {
      this.getEntityListData(1)
    },
    searchPropertyUpdated(inputField) {
      let val = inputField.field.field_value
      this.searchProperty = val
    },
    divisionUpdated(inputField) {
      let val = inputField.field.field_value
      this.selectedDivision = val
    },
    searchValueUpdated(inputField) {
      let val = inputField.field.field_value
      this.searchValue = val
    },
    userSearchUpdated(field) {
      let val = field.field.field_value
      this.userSearch = val
      clearTimeout(this.userSearchTimeOut)
      this.userSearchTimeOut = setTimeout(() => {
        this.getEntityListData(1) //this.agGrid.gridApi.setQuickFilter(val);
      }, 200)
    },
    getEntityListData(page) {
      this.getEntityList({
        page: page,
        statusId: this.statusId,
        searchProperty: this.searchProperty,
        searchValue: this.searchValue,
        divisionId: this.selectedDivision,
        divisionLabel: this.defaultRouteDivision,
      }).then(response => {
        this.buildAgGridData(response)
      })
      this.currentPage = page
    },
    buildAgGridData(response) {
      this.agGrid.rowData = response.rows;
      this.recordsCounter = response.count;
      this.amReady = true
    },
    resetSearchFields() {
      this.amReady = false
      $vue.nextTick(() => {
        this.amReady = true
        this.getEntityListData(this.currentPage)
      })

    },
    destinationChanged() {
      this.getEntityListData(this.currentPage)
    },
    vendorChanged() {
      this.getEntityListData(this.currentPage)
    },
    ...$mapActions('voip-rate-division-api', {getDivisionsDropDownList: 'getDropDownList'}),
    ...$mapActions('voip-vendor-destination-status-api', {
      getEntityList: 'list'
    }),
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      this.getEntityListData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
